export const language: any = {
  selected_ingredients: 'Selected ingredients',
  recommend: 'Recommended dishes',
  title_detail: 'Recommended Recipes',
  share: 'Share',
  ingredients: {
    title: `<span class="tracking-tighter whitespace-nowrap">Ingredients</span> <span class="tracking-tighter whitespace-nowrap">(1 serving)</span>`,
    add_all: 'Add all ingredients',
    view_more: '{number} more ingredients',
    view_less: 'Fold',
    delete_all: 'Delete all ingredients',
  },
  how_to_cook: 'Cooking method',
  video: {
    title: 'Video recipe',
  },
  msg: {
    msg_1: "Are you sure you want to delete this ingredients?",
    msg_2: "Are you sure you want to delete all ingredients?",
    msg_3: "Would you like to add the ingredients?",
    msg_4: "Would you like to add all the missing ingredients?",
    msg_5: "Would you like to add the selected ingredients to your shopping cart?",
    msg_6: "This ingredient is already in your shopping cart.",
    confirm: "Yes",
    cancel: "No",
  },
  recipe_exist_in_cart:"This ingredient is already in your shopping cart.",
  recipe_want_add_to_cart:"Would you like to add the selected ingredients to your shopping cart?",
  recipe_exist_in_cart_should_exclued:"is already in the current cart, so it has been excluded.",
  calories_description: "This dish is estimated to provide {calories} based on the recipe below. Please consider to make the right choice for your health!",
  title_share_sns: "Share this recipe on",
  copy: "Copy",
  recipe_add_cart_success: "Added to cart. Would you like to go to the cart screen?",
  recipe_close: "Close",
  recipe_move: "Move",
  recipe_add_ingredient_success: "The selected ingredient has been added. Do you want to switch to the ingredients screen?",
  copied: "Copied",
  text_share_sns: `{recipe_name} how about this recipe?\nCheck it out on Hey! Cooker!`,
  search: {
    title: "Search for Recipes",
    searching: "Hey Cooker is searching for recipes that match<br/> your keywords, please wait a moment!",
    not_found: "Hmm, the AI chef couldn't find any dishes that match<br/> your keywords, please try entering another dish name.",
    placeholder: "Enter the recipe name you want to search for...",
    msg_default_recipe: "You don't have any recipes yet",
  },
  noData: "No results found",
  searching: "Searching..."
}
